import React from 'react';
import { ErrorBoundaryPage } from '@/app/pages/error-boundary';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorInfo {
  componentStack: string;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, { error: Error | null; errorInfo: ErrorInfo | null }> {
  public state: { error: Error | null; errorInfo: ErrorInfo | null };
  public props: ErrorBoundaryProps;

  static getDerivedStateFromError(error: Error): { error: Error; errorInfo: ErrorInfo } {
    return {
      error,
      errorInfo: { componentStack: '' }
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // You can log error to an error reporting service here
    // logErrorToService(error, errorInfo);
  }

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null, errorInfo: null };
    this.props = props;
  }

  render(): React.ReactNode {
    const { error, errorInfo } = this.state;

    if (error) {
      return (
        <ErrorBoundaryPage 
          error={error} 
          errorInfo={errorInfo} 
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
